import React, { useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form/dist/react-hook-form.ie11';
import { Container, Form, Row, Col } from "react-bootstrap";
import SvgIcon from '@material-ui/core/SvgIcon';
import ChartMetrics from '../icons/chart-metrics.svg';
import { StyledRadioInput, TextInput, SelectInput } from "../../../Helpers/Inputs/index";
import { IDAHO, KENTUCKY, FLORIDA, COLORADO, SOUTH_CAROLINA, IOWA } from '../../../Helpers/Constants/States';
import { object, string, number as yupnumber, array as yuparray, mixed, date } from '../../../Helpers/Validators/customValidators';
import { emptyStringToUndefined } from '../../../Helpers/Formatters/EmptyStringToUndefined.js';
import InsurancePolicyForm from './InsurancePolicyForm';
import BackNext from '../../Common/SubComponents/BackNext';

const selectedStateList = [KENTUCKY, SOUTH_CAROLINA];

export default function ReplacingInfo(props) {

    const getreasonOfReplacementOptions = () => {
        return (
            [
                { value: "Additional Benefits", label: "Additional Benefits" },
                { value: "Fewer Benefits and Lower Premiums", label: "Fewer Benefits and Lower Premiums" },
                { value: "No Change in Benefits, But Lower Premiums", label: "No Change in Benefits, But Lower Premiums" },
                { value: "Other (Specify)", label: "Other (Specify)" },
            ]
        )
    }
    const state = props.basicInfo.state;
    const getNumberOfPoliciesOptions = () => {
        let policyOptions = [
            { value: 1, label: "1" },
            { value: 2, label: "2" },
        ]
        if (selectedStateList.includes(state)) {
            policyOptions.unshift({ value: 0, label: "0" });
        }
        return policyOptions;
    }

    const { register, errors, handleSubmit, setValue, triggerValidation, reset } = useForm({
        validationSchema: ReplacingInfo.ValidationSchema(),
        mode: 'onBlur',
        reValidateMode: 'onBlur',
    });
    const handleValueChange = (field, value) => {
        setValue(field, value);
        props.onFieldChange(field, value);
        triggerValidation(field);
    };
    
    useEffect(() => {
        if (props.formState.numberOfPolicies === '0' && (state !== KENTUCKY && state !== SOUTH_CAROLINA)) {
            handleValueChange("numberOfPolicies", '');
        }
    }, [])

    useEffect(() => {
        register({ name: 'replaceExistingCoverage' });
        setValue('replaceExistingCoverage', props.formState.replaceExistingCoverage);

        register({ name: 'existingHealthInsurance' });
        setValue('existingHealthInsurance', props.formState.existingHealthInsurance);

        register({ name: 'existingSimilarHealthInsurance' });
        setValue('existingSimilarHealthInsurance', props.formState.existingSimilarHealthInsurance);
        register({ name: 'replaceExistingAccidentCoverage' });
        setValue('replaceExistingAccidentCoverage', props.formState.replaceExistingAccidentCoverage);

        register({ name: 'numberOfPolicies' });
        setValue('numberOfPolicies', props.formState.numberOfPolicies);

        props.formState.insurancePolicies.forEach((policies, index) => {
            register({ name: `insurancePolicies[${index}].company` });
            setValue(`insurancePolicies[${index}].company`, policies.company);

            register({ name: `insurancePolicies[${index}].policyNumber` });
            setValue(`insurancePolicies[${index}].policyNumber`, policies.policyNumber);

            register({ name: `insurancePolicies[${index}].faceAmount` });
            setValue(`insurancePolicies[${index}].faceAmount`, policies.faceAmount);

            register({ name: `insurancePolicies[${index}].insuranceDate` });
            setValue(`insurancePolicies[${index}].insuranceDate`, policies.insuranceDate);

            register({ name: `insurancePolicies[${index}].replaceExistingCoverageType` });
            setValue(`insurancePolicies[${index}].replaceExistingCoverageType`, policies.replaceExistingCoverageType);
        })
        register({ name: 'existingCoverageWithAflac' });
        setValue('existingCoverageWithAflac', props.formState.existingCoverageWithAflac);
        /// As per new requrement commented the code
        // register({ name: 'existingCoverageBoth' });
        // setValue('existingCoverageBoth', props.formState.existingCoverageBoth);

        // register({ name: 'policyNumberHCI' });
        // setValue('policyNumberHCI', props.formState.policyNumberHCI);

        // register({ name: 'policyNumberHCSI' });
        // setValue('policyNumberHCSI', props.formState.policyNumberHCSI);

        register({ name: 'existingMedicaidSLMB' });
        setValue('existingMedicaidSLMB', props.formState.existingMedicaidSLMB);

        register({ name: 'existingMedicaidQMB' });
        setValue('existingMedicaidQMB', props.formState.existingMedicaidQMB);

        register({ name: 'existingMedicaidOther' });
        setValue('existingMedicaidOther', props.formState.existingMedicaidOther);

        register({ name: 'reasonOfReplacement' });
        setValue('reasonOfReplacement', props.formState.reasonOfReplacement);

        register({ name: 'reasonOfReplacementSpecify' });
        setValue('reasonOfReplacementSpecify', props.formState.reasonOfReplacementSpecify);

        register({ name: 'state' });
        setValue('state', state);
    }, [register,props.formState.numberOfPolicies])


    const handleNumberOfPolicyChange = (policyNumber) => {
        const numberOfExistingPolicies = Number(policyNumber);
        const insurancePolicies = props.formState.insurancePolicies.length;
        let totalPolicyToUpdate = props.formState.insurancePolicies;
        if (numberOfExistingPolicies >= 0)
        {
            if (insurancePolicies > numberOfExistingPolicies) {
                for (let i = 0; i < insurancePolicies - numberOfExistingPolicies; i++) {
                    totalPolicyToUpdate.pop();
                }
                props.setMultiField(totalPolicyToUpdate, policyNumber);
                reset();
            }
            else if (insurancePolicies < numberOfExistingPolicies) {
                addNewInsurancePolicy(policyNumber, numberOfExistingPolicies - insurancePolicies);
            }
            else {
                props.onFieldChange('numberOfPolicies', policyNumber);
            }
        }
    }

    const onSubmit = () => {
        if (props.formState.existingCoverageWithAflac === "Yes") {
            props.goToStep();
        }
        else {
            props.onNext();
        }
    };


    const addNewInsurancePolicy = (value, numberOfNewForm) => {
        let newForm = props.formState.insurancePolicies;
        for (let i = 0; i < numberOfNewForm; i++) {
            register({ name: `insurancePolicies[${i}].company` });
            register({ name: `insurancePolicies[${i}].policyNumber` });
            register({ name: `insurancePolicies[${i}].faceAmount` });
            register({ name: `insurancePolicies[${i}].insuranceDate` });
            register({ name: `insurancePolicies[${i}].replaceExistingCoverageType` });
            const newData = ReplacingInfo.DefaultFormState().insurancePolicies[0];
            newForm.push(newData);
        }

        props.setMultiField(newForm, value);
    }

    const forms = props.formState.insurancePolicies.map((insurancePoliciesFormState, index) =>
        <InsurancePolicyForm
            formState={insurancePoliciesFormState}
            onChange={(newForm) => {
                props.onFieldChange(
                    'insurancePolicies',
                    props.formState.insurancePolicies.map((form, formIndex) => {
                        return formIndex === index ? newForm : form;
                    })
                );
            }}
            setValue={setValue}
            trigger={triggerValidation}
            key={index}
            index={index}
            register={register}
            errors={errors.insurancePolicies && errors.insurancePolicies[index]}
            state={state}
            existingHealthInsurance={props.formState.existingHealthInsurance}
            replaceExistingCoverage={props.formState.replaceExistingCoverage}
            existingSimilarHealthInsurance={props.formState.existingSimilarHealthInsurance}
        />
    )

    let replaceExistingCoverageLabel;
    if (state !== IDAHO && state !== IOWA) {
        replaceExistingCoverageLabel = 'Is this insurance intended to replace any other health insurance now in force?'
    }
    if (state === IDAHO || state === IOWA) {
        replaceExistingCoverageLabel = 'Is this insurance intended to replace any other accident and sickness insurance presently in force?'
    }

    return (
        <Container fluid className='border-class'>
            <Form onSubmit={handleSubmit(onSubmit)}>
                <Row className="justify-content-center pt-3">
                    <Col lg={5}>
                        <div className="text-center mb-2 pt-4"><SvgIcon component={ChartMetrics} className="small-icons" color="primary" fontSize="large" /></div>
                        <div className="text-center mb-4 form-title">Replacement Information</div>

                        {state === COLORADO &&
                            <Fragment>
                                <Form.Group>
                                    <p className="section-title">Do you have another accident and sickness insurance policy in force?</p>
                                    <StyledRadioInput
                                        name="existingHealthInsurance"
                                        id="existingHealthInsurance"
                                        value={props.formState.existingHealthInsurance}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('existingHealthInsurance', e)}
                                        errors={errors && errors.existingHealthInsurance}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>

                                {props.formState.existingHealthInsurance === "Yes" &&
                                    <Form.Group>
                                        <TextInput
                                            name="company"
                                            id="company"
                                            label="Company Name"
                                            value={props.formState.company}
                                            errors={errors && errors.company}
                                            inputRef={register}
                                            onChange={(e) => handleValueChange('company', e.target.value)}
                                        />
                                    </Form.Group>
                                }


                                {props.formState.existingHealthInsurance === "Yes" && state === COLORADO &&
                                    <Form.Group>
                                        <p className="section-title">Do you intend to replace your current accident and sickness insurance policy with this policy?	</p>
                                        <StyledRadioInput
                                            name="replaceExistingAccidentCoverage"
                                            id="replaceExistingAccidentCoverage"
                                            value={props.formState.replaceExistingAccidentCoverage}
                                            options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                            onChange={e => handleValueChange('replaceExistingAccidentCoverage', e)}
                                            errors={errors && errors.replaceExistingAccidentCoverage}
                                            isWhiteBackground={true}
                                            isBlankIcon={true}
                                        />
                                    </Form.Group>}
                                <Form.Group>
                                    <p className="section-title">Do you have any other accident and sickness insurance that provides benefits similar to this accident and sickness policy?</p>
                                    <StyledRadioInput
                                        name="existingSimilarHealthInsurance"
                                        id="existingSimilarHealthInsurance"
                                        value={props.formState.existingSimilarHealthInsurance}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('existingSimilarHealthInsurance', e)}
                                        errors={errors && errors.existingSimilarHealthInsurance}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>

                                {props.formState.existingSimilarHealthInsurance === "Yes" &&
                                    <React.Fragment>
                                        <Form.Group>
                                            <TextInput
                                                name="similarCompany"
                                                id="similarCompany"
                                                label="Company Name"
                                                value={props.formState.similarCompany}
                                                errors={errors && errors.similarCompany}
                                                inputRef={register}
                                                onChange={(e) => handleValueChange('similarCompany', e.target.value)}
                                            />
                                        </Form.Group>
                                        <Form.Group>
                                            <TextInput
                                                name="replaceExistingCoverageType"
                                                id="replaceExistingCoverageType"
                                                label="Policy Type"
                                                value={props.formState.replaceExistingCoverageType}
                                                errors={errors && errors.replaceExistingCoverageType}
                                                inputRef={register}
                                                onChange={(e) => handleValueChange('replaceExistingCoverageType', e.target.value)}
                                            />
                                        </Form.Group>
                                    </React.Fragment>
                                }
                            </Fragment>
                        }
                        <Form.Group>
                            <p className="section-title">{replaceExistingCoverageLabel}</p>
                            <StyledRadioInput
                                name="replaceExistingCoverage"
                                id="replaceExistingCoverage"
                                value={props.formState.replaceExistingCoverage}
                                options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                onChange={e => handleValueChange('replaceExistingCoverage', e)}
                                errors={errors && errors.replaceExistingCoverage}
                                isWhiteBackground={true}
                                isBlankIcon={true}
                            />
                        </Form.Group>

                        {(state === COLORADO && props.formState.replaceExistingCoverage === "Yes") &&
                            <Form.Group>
                                <SelectInput
                                    name="reasonOfReplacement"
                                    id="reasonOfReplacement"
                                    value={props.formState.reasonOfReplacement}
                                    onChange={e => handleValueChange('reasonOfReplacement', e.target.value)}
                                    label="Reason For Replacement"
                                    selectOptions={getreasonOfReplacementOptions()}
                                    errors={errors && errors.reasonOfReplacement}
                                />
                            </Form.Group>
                        }

                        {(state === COLORADO && props.formState.replaceExistingCoverage === "Yes" && props.formState.reasonOfReplacement === "Other (Specify)") &&
                            <Form.Group>
                                <TextInput
                                    name="reasonOfReplacementSpecify"
                                    id="reasonOfReplacementSpecify"
                                    label="Other (Specify)"
                                    value={props.formState.reasonOfReplacementSpecify}
                                    errors={errors && errors.reasonOfReplacementSpecify}
                                    onChange={(e) => handleValueChange('reasonOfReplacementSpecify', e.target.value)}
                                    inputRef={register}
                                />
                            </Form.Group>
                        }

                        {state === SOUTH_CAROLINA && <p className="section-title">Please list all accident and health insurance you have in force:</p>}
                        {state === KENTUCKY && <p className="section-title">List all health insurance now in force:</p>}
                        {(state === FLORIDA && props.formState.replaceExistingCoverage === "Yes") && <p className="section-title">Please provide the company name, policy number and issue date of the policies being replaced:</p>}

                        {((selectedStateList.includes(state)) || (state === FLORIDA && props.formState.replaceExistingCoverage === "Yes")) &&
                            <Form.Group>
                                <SelectInput
                                    name="numberOfPolicies"
                                    id="numberOfPolicies"
                                    value={props.formState.numberOfPolicies}
                                    onChange={e => {
                                        handleNumberOfPolicyChange(e.target.value)
                                    }}
                                    label="Number of Policies"
                                    selectOptions={getNumberOfPoliciesOptions()}
                                    errors={errors && errors.numberOfPolicies}
                                />
                            </Form.Group>
                        }

                        {props.formState.numberOfPolicies >= 1 ? forms : null}
                    </Col>
                </Row>

                <Row className="justify-content-center second-section replacemnt-hospital-info">
                    <Col lg={5}>
                        <Form.Group>
                            <p className="section-title">Do you have any other hospital confinement indemnity or hospital confinement sickness indemnity coverage with Aflac?</p>
                            <StyledRadioInput
                                name="existingCoverageWithAflac"
                                id="existingCoverageWithAflac"
                                value={props.formState.existingCoverageWithAflac}
                                options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                onChange={e => handleValueChange('existingCoverageWithAflac', e)}
                                errors={errors && errors.existingCoverageWithAflac}
                                isWhiteBackground={true}
                                isBlankIcon={true}
                            />
                        </Form.Group>
                        {/* As per new requrement commented the code */}
                        {/* <Form.Group>
                            <p className="section-title">Do you have both hospital confinement indemnity and hospital confinement sickness indemnity coverage in force now?</p>
                            <StyledRadioInput
                                name="existingCoverageBoth"
                                id="existingCoverageBoth"
                                value={props.formState.existingCoverageBoth}
                                options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                onChange={e => handleValueChange('existingCoverageBoth', e)}
                                errors={errors && errors.existingCoverageBoth}
                                isWhiteBackground={true}
                                isBlankIcon={true}
                            />
                        </Form.Group>

                        {props.formState.existingCoverageBoth === "Yes" &&
                            <Fragment>
                                <Form.Group>
                                    <TextInput
                                        name="policyNumberHCI"
                                        id="policyNumberHCI"
                                        label="Hospital Confinement Indemnity Insurance Policy Number"
                                        value={props.formState.policyNumberHCI}
                                        errors={errors && errors.policyNumberHCI}
                                        onChange={(e) => handleValueChange('policyNumberHCI', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                                <Form.Group>
                                    <TextInput
                                        name="policyNumberHCSI"
                                        id="policyNumberHCSI"
                                        label="Hospital Confinement Sickness Indemnity Insurance Policy Number"
                                        value={props.formState.policyNumberHCSI}
                                        errors={errors && errors.policyNumberHCSI}
                                        onChange={(e) => handleValueChange('policyNumberHCSI', e.target.value)}
                                        inputRef={register}
                                    />
                                </Form.Group>
                            </Fragment>
                        } */}

                        {(state === COLORADO) &&
                            <Fragment>
                                <p className="section-title">Are you covered for medical assistance through the state Medicaid program, Health First Colorado:</p>
                                <Form.Group>
                                    <p className="section-title">As a Specified Low-Income Medicare Beneficiary (SLMB)?</p>
                                    <StyledRadioInput
                                        name="existingMedicaidSLMB"
                                        id="existingMedicaidSLMB"
                                        value={props.formState.existingMedicaidSLMB}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('existingMedicaidSLMB', e)}
                                        errors={errors && errors.existingMedicaidSLMB}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <p className="section-title">As a Qualified Medicare Beneficiary (QMB)?</p>
                                    <StyledRadioInput
                                        name="existingMedicaidQMB"
                                        id="existingMedicaidQMB"
                                        value={props.formState.existingMedicaidQMB}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('existingMedicaidQMB', e)}
                                        errors={errors && errors.existingMedicaidQMB}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <p className="section-title">For other Medicaid medical benefits?</p>
                                    <StyledRadioInput
                                        name="existingMedicaidOther"
                                        id="existingMedicaidOther"
                                        value={props.formState.existingMedicaidOther}
                                        options={[{ value: "Yes", label: "Yes" }, { value: "No", label: "No" }]}
                                        onChange={e => handleValueChange('existingMedicaidOther', e)}
                                        errors={errors && errors.existingMedicaidOther}
                                        isWhiteBackground={true}
                                        isBlankIcon={true}
                                    />
                                </Form.Group>
                            </Fragment>
                        }
                    </Col>
                </Row>
                <div className='backnext-wrapper'>
                    <BackNext onBack={props.onBack} isAflac={true} continueLabel={{text: "Next"}} />
                </div>
            </Form>
        </Container>
    );
}

ReplacingInfo.propTypes = {
    formState: PropTypes.object.isRequired,
    onNext: PropTypes.func,
    onFieldChange: PropTypes.func.isRequired,
    onBack: PropTypes.func,
};

ReplacingInfo.ValidationSchema = () => {
    return object().shape({
        replaceExistingCoverage: string().required("This field is required."),
        replaceExistingAccidentCoverage: string().when(['state', 'existingHealthInsurance'], {
            is: (state, existingHealthInsurance) => state === COLORADO && existingHealthInsurance === "Yes",
            then: string().required("This field is required."),
            otherwise: string().notRequired(),
        }),
        existingHealthInsurance: string().when('state', {
            is: COLORADO,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        existingSimilarHealthInsurance: string().when('state', {
            is: COLORADO,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        company: string().when(['state', 'existingHealthInsurance'], {
            is: (state, existingHealthInsurance) => state === COLORADO && existingHealthInsurance === "Yes",
            then: string().required("Company name is required."),
            otherwise: string().notRequired()
        }),
        replaceExistingCoverageType: string().when(['state', 'existingSimilarHealthInsurance'], {
            is: (state, existingSimilarHealthInsurance) => state === COLORADO && existingSimilarHealthInsurance === "Yes",
            then: string().required("Type of policy is required."),
            otherwise: string().notRequired()
        }),
        similarCompany: string().when(['state', 'existingSimilarHealthInsurance'], {
            is: (state, existingSimilarHealthInsurance) => state === COLORADO && existingSimilarHealthInsurance === "Yes",
            then: string().required("Company name is required."),
            otherwise: string().notRequired()
        }),
        existingCoverageWithAflac: string().required("This field is required."),
        // existingCoverageBoth: string().required("This field is required."),
        // policyNumberHCI: yupnumber().when('existingCoverageBoth', {
        //     is: "Yes",
        //     then: yupnumber()
        //         .transform(emptyStringToUndefined)
        //         .required("Hospital Confinement Indemnity Number is required.")
        //         .typeError("Must be a number."),
        //     otherwise: yupnumber()
        //         .transform(emptyStringToUndefined)
        //         .notRequired()
        // }),
        // policyNumberHCSI: yupnumber().when('existingCoverageBoth', {
        //     is: "Yes",
        //     then: yupnumber()
        //         .transform(emptyStringToUndefined)
        //         .required("Hospital Confinement Sickness Indemnity Number is required.")
        //         .typeError("Must be a number."),
        //     otherwise: yupnumber()
        //         .transform(emptyStringToUndefined)
        //         .notRequired()
        // }),
        existingMedicaidSLMB: string().when('state', {
            is: COLORADO,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        existingMedicaidQMB: string().when('state', {
            is: COLORADO,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        existingMedicaidOther: string().when('state', {
            is: COLORADO,
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        reasonOfReplacement: string().when(['state', 'replaceExistingCoverage',], {
            is: (state, replaceExistingCoverage) => (state === COLORADO && replaceExistingCoverage === "Yes"),
            then: string().required("Reason of replacement is required."),
            otherwise: string().notRequired()
        }),
        reasonOfReplacementSpecify: string().when(['reasonOfReplacement', 'replaceExistingCoverage'], {
            is: (reasonOfReplacement, replaceExistingCoverage) => (reasonOfReplacement === "Other (Specify)" && replaceExistingCoverage === "Yes"),
            then: string().required("Reason of replacement is required."),
            otherwise: string().notRequired()
        }),
        numberOfPolicies: string().when(['state', 'replaceExistingCoverage'], {
            is: (state, replaceExistingCoverage) => ((selectedStateList.includes(state)) || (state === FLORIDA && replaceExistingCoverage === "Yes")),
            then: string().required("This field is required."),
            otherwise: string().notRequired()
        }),
        insurancePolicies: mixed().when(['state', 'replaceExistingCoverage'], {
            is: (state, replaceExistingCoverage) => state === FLORIDA && replaceExistingCoverage === "Yes",
            then: yuparray(object().shape({
                company: string().required("Company Name is required."),
                policyNumber: string().required("Policy Number is required"),
                insuranceDate: date().transform(emptyStringToUndefined)
                    .typeError('Invalid date.')
                    .required('Insurance date is required.'),
            })),
            otherwise: mixed().notRequired()
        })
    })
};

ReplacingInfo.DefaultFormState = (prefill = false) => {
    return {
        replaceExistingCoverage: prefill ? "No" : '',
        existingHealthInsurance: '',
        existingSimilarHealthInsurance: '',
        company: '',
        replaceExistingCoverageType: '',
        similarCompany: '',
        numberOfPolicies: '',
        insurancePolicies: [
            {
                company: '',
                policyNumber: '',
                faceAmount: '',
                insuranceDate: '',
                replaceExistingCoverageType: '',
            }
        ],
        existingCoverageWithAflac: prefill ? "No" : '',
        // existingCoverageBoth: prefill ? "No" : '',
        //policyNumberHCI: '',
        //policyNumberHCSI: '',
        existingMedicaidSLMB: '',
        existingMedicaidQMB: '',
        existingMedicaidOther: '',
        reasonOfReplacement: '',
        reasonOfReplacementSpecify: '',
        replaceExistingAccidentCoverage: ""
    };
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Aflac/steps/ReplacingInfo.js